




















import { Vue, Component, Watch } from 'vue-property-decorator';

import UnorderedList from '@/components/Atoms/List/UnorderedList.vue';
import ListItem from '@/components/Atoms/ListItem/ListItem.vue';
import RadioButtonDisabledExtension from '@/components/Atoms/Input/RadioButtonDisabledExtension.vue';

@Component({
  components: {
    UnorderedList,
    ListItem,
    RadioButtonDisabledExtension,
  },
})
export default class BuildingType extends Vue {
  public buildingTypeList: { id: string; text: string; disabled: boolean; }[] = [
    {
      id: 'family',
      text: 'ファミリータイプ(⼀⼾建て・商業ビル・オフィスビル)',
      disabled: false,
    },
    {
      id: 'mansion',
      text: 'マンションタイプ(集合住宅)',
      disabled: false,
    },
  ];

  // ご利用中の光回線はありますか
  get entryType(): string {
    return this.$store.getters['hikari/entryType'];
  }
  // 現在ご利用中の回線タイプが変更された場合に検知する
  @Watch('entryType')
  onEntryTypeChanged(newVal: string) {
    this.buildingTypeList[1].disabled = (newVal == 'reuse');
  }

  // ライフサイクルの関係でコンポーネントがマウントされレンダリングされた後に、回線タイプの変更された時のロジックを実行する。
  mounted() {
    this.onEntryTypeChanged(this.entryType);
  }
}
